import styled from "styled-components";
import { Menu } from "antd";

export const SidebarMenu = styled(Menu) <{ inlineCollapsed: boolean }>`
	box-shadow: 0 3px 6px 0 rgba(167, 167, 167, 0.1);
	background-color: #000;
	/* Fills the sidebar and grows with an open group, so the black background reaches the end when it scrolls. */
	flex: 1 0 auto;
	text-align: center;
	font-size: 19px;
	display: flex;
	flex-direction: column;
	align-items: center;
	font-family: "Roboto" !important;
	font-weight: 600;
	padding-top: 50px;
	user-select: none;
	-webkit-user-select: none;
	-webkit-tap-highlight-color: transparent;

	.nav-link {
		font-family: "Roboto" !important;
		font-weight: 400 !important;
		color: rgba(255, 255, 255, 0.6) !important;
		transition: color 0.2s ease;
	}

	.nav-link:hover {
		color: #fff !important;
	}

	.nav-header.active {
		color: #ed1c24 !important;
	}

	.nav-header {
		color: #fff !important;
	}

	.nav-group {
		color: #fff;
		transition: color 0.3s ease;
	}

	.nav-group.active {
		color: #ed1c24 !important;
	}

	.nav-link.active {
		font-weight: 500 !important;
		color: #fff !important;
	}

	.disabled-header {
		color: #2e333e !important;
		pointer-events: none;
	}

	.disabled-link {
		font-family: "Roboto" !important;
		font-weight: 500 !important;
		pointer-events: none;
	}

	.ant-menu-submenu-title {
		padding: 0 !important;
		margin: 0 !important;
		outline: none !important;
		box-shadow: none !important;
		background-color: transparent !important;
	}

	.ant-menu-submenu-title:focus,
	.ant-menu-submenu-title:focus-visible,
	.ant-menu-item:focus,
	.ant-menu-item:focus-visible {
		outline: none !important;
		box-shadow: none !important;
	}

	.ant-menu-submenu-title:active,
	.ant-menu-item:active {
		background-color: transparent !important;
	}

	.ant-menu-submenu-arrow,
	.ant-menu-submenu-arrow::before,
	.ant-menu-submenu-arrow::after {
		color: rgba(255, 255, 255, 0.5) !important;
		transition: color 0.2s ease, transform 0.3s ease !important;
	}

	.ant-menu-submenu-title:hover .ant-menu-submenu-arrow,
	.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after,
	.ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
		color: #fff !important;
	}

	.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow,
	.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
	.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
		color: #ed1c24 !important;
	}

	.ant-menu-submenu,
	.ant-menu-item {
		padding: 5px 5px 5px 9px !important;
		margin: 0 0 16px !important;
		color: #fff;
		margin-bottom: 16px;
		line-height: 1.38;
		letter-spacing: normal;
		text-align: left;
		width: 100%;
	}

	.ant-menu-sub {
		background-color: transparent !important;
		font-size: 15px;
		position: relative;
		margin: 4px 0 0 18px !important;
		padding: 4px 0 !important;
		border-left: 1px solid rgba(255, 255, 255, 0.15);
	}

	.ant-menu-item:first {
		margin-top: 16px !important;
	}

	.ant-menu-item {
		height: 52px;
	}

	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child {
		position: relative;
		display: flex;
		align-items: center;
		height: 36px;
		padding: 0 12px 0 20px !important;
		margin: 2px 12px 2px 0 !important;
		width: calc(100% - 12px);
		border-radius: 0 8px 8px 0;
		transition: background-color 0.3s ease !important;
	}

	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child::before {
		content: "";
		position: absolute;
		left: -1px;
		top: 6px;
		bottom: 6px;
		width: 3px;
		border-radius: 0 3px 3px 0;
		background: #ed1c24;
		transform: scaleY(0);
		opacity: 0;
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
	}

	/* Only the colour changes: the text of an entry stays where it is when it becomes active (no sliding). */
	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child .nav-link {
		transition: color 0.3s ease;
	}

	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child:hover {
		background-color: rgba(255, 255, 255, 0.06) !important;
	}

	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child:has(.nav-link.active) {
		background-color: rgba(237, 28, 36, 0.12) !important;
	}

	.ant-menu-sub .ant-menu-item.ant-menu-item-only-child:has(.nav-link.active)::before {
		transform: scaleY(1);
		opacity: 1;
	}

	.ant-menu-inline {
		margin-top: 8px;
	}

	.ant-menu-submenu-title svg {
		color: #fff;
	}

	.ant-menu-item-selected {
		color: #2e333e;
		background-color: transparent !important;
	}

	.ant-menu-title-content {
		color: #fff;
	}

	.ant-menu-submenu-selected > .ant-menu-submenu-title {
		color: #fff;
	}

	.ant-menu-item:hover,
	.ant-menu-submenu:hover {
		background-color: transparent !important;
	}

	.ant-menu-item-icon {
		background-color: #000 !important;	
		color: #fff !important;
	}

	.ant-menu-item-icon.active {
		color: #ed1c24 !important;
	}

	.anticon svg {
		font-size: 18px !important;
	}
`;

export const SidebarImage = styled.div`
	padding: 8px;
	background-color: #e0effd;
	border-radius: 8px;
`;


export const SidebarContainer = styled.div<{ collapsed: boolean }>`
	width: ${({ collapsed }) => (collapsed ? "80px" : "260px")};
	transition: width 0.2s;
	position: fixed; 
	left: 0; 
	top: 64px;
	bottom: 0;
	display: flex;
	flex-direction: column;
	/* A short screen (or an open group) can make the menu taller than the window: it scrolls on its own then. */
	overflow-x: hidden;
	overflow-y: auto;
	/* Where scrollbars take space (a mouse on macOS, Windows), the space is kept even when the menu fits, so opening or
	   closing a group never makes the entries narrower or wider; the black background fills that space. The collapsed
	   sidebar has no inline groups and keeps its icons centred. */
	scrollbar-gutter: ${({ collapsed }) => (collapsed ? "auto" : "stable")};
	background-color: #000;
	overscroll-behavior: contain;
	scrollbar-width: thin;
	scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
`;
